import { useAssetTransformationTaskGalleryUpdate } from '~/components/AssetTransformationTasks/useAssetTransformationTaskGalleryUpdate';
import { isVideoClipTask } from '~/components/VideoClipTasks/isVideoClipTask';

export const useVideoClipTaskGalleryUpdate = () => {
  const { onTaskComplete } = useAssetTransformationTaskGalleryUpdate(isVideoClipTask);

  return { onVideoClipTaskComplete: onTaskComplete };
};
